import { render, staticRenderFns } from "./XmlRepositorie.vue?vue&type=template&id=fa8e9bbe&"
import script from "./XmlRepositorie.vue?vue&type=script&lang=js&"
export * from "./XmlRepositorie.vue?vue&type=script&lang=js&"
import style0 from "./XmlRepositorie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports